import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import parse from 'html-react-parser';
import { useLocation } from 'react-use';
import { StatusCode } from '@hungryroot/rest';
import { getApiV2Homepage } from '@hungryroot/rest/api/v2/homepage/get';
import styles from './PromoBanner.module.css';

export function PromoBanner() {
  const loc = useLocation();

  const searchParams = useMemo(() => {
    return new URLSearchParams(loc.search);
  }, [loc.search]);

  const { data: homepageData } = useQuery({
    queryKey: ['homepage', { searchParams: Object.fromEntries(searchParams) }],
    queryFn: async () => {
      const resp = await getApiV2Homepage({
        search: searchParams,
      });
      if (resp.status !== StatusCode.SuccessOK) {
        throw resp;
      }
      return resp.data;
    },
  });

  const bannerText = homepageData?.banner?.text;

  const bannerChildren = useMemo(() => {
    if (bannerText === undefined) {
      return;
    }
    return parse(bannerText);
  }, [bannerText]);

  if (homepageData === undefined) {
    return <div className={styles.placeholder} />;
  }

  return (
    <div className={styles.container} data-testid="promo-banner">
      <div className={styles['container-inner']}>
        {homepageData.banner?.image_url && (
          <img
            data-testid="promo-banner-decorative-image"
            alt=""
            src={homepageData.banner.image_url}
            className={styles.image}
          />
        )}
        <div className={styles['text-container']}>{bannerChildren}</div>
      </div>
    </div>
  );
}
